import enUS from 'date-fns/locale/en-US';
import formatLong from './_lib/formatLong/index.esm.js';

var locale = {
  code: 'en-ZA',
  formatDistance: enUS.formatDistance,
  formatLong: formatLong,
  formatRelative: enUS.formatRelative,
  localize: enUS.localize,
  match: enUS.match,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
  }
};

export default locale;
//# sourceMappingURL=index.esm.js.map
